import { ROLES } from './roles';
import text from 'static/text_display.json';
import { serviceTypes } from 'utils/constants/serviceTypes.js';
import { FEATURES } from 'utils/constants/products';

export const infoText = 'ⓘ';

export const PAGE_URLS = {
  CLEANING_TASKS: {
    link: '/tasks/cleaning',
    name: 'Cleaning',
    services: [serviceTypes.cleaning],
    roles: [
      ROLES.SECURITY_COMPANY_MANAGER.id,
      ROLES.MANAGER.id,
      ROLES.SUPERVISOR.id,
    ],
  },
  SECURITY_TASKS: {
    link: '/tasks/security',
    name: 'Security',
    services: [serviceTypes.security],
    roles: [
      ROLES.SECURITY_COMPANY_MANAGER.id,
      ROLES.MANAGER.id,
      ROLES.SUPERVISOR.id,
    ],
  },
  TEMPLATE_PATROLS: {
    link: '/tasks/patrol-templates',
    name: 'Patrol Templates',
    services: [serviceTypes.patrol.multiSite, serviceTypes.patrol.singleSite],
    roles: [ROLES.SECURITY_COMPANY_MANAGER.id, ROLES.MANAGER.id],
  },
  PATROLS: {
    link: '/tasks/patrol-tasks',
    name: 'Patrols',
    services: [serviceTypes.patrol.multiSite, serviceTypes.patrol.singleSite],
    roles: [
      ROLES.SECURITY_COMPANY_MANAGER.id,
      ROLES.MANAGER.id,
      ROLES.SUPERVISOR.id,
    ],
  },
  TEMPLATE_TASKS: {
    link: '/tasks/template',
    name: 'Task Templates',
    services: [
      serviceTypes.cleaning,
      serviceTypes.maintenance,
      serviceTypes.security,
    ],
    roles: [ROLES.SECURITY_COMPANY_MANAGER.id, ROLES.MANAGER.id],
  },
  TASK_TYPES: {
    link: '/tasks/task-types',
    name: 'Task Types',
    services: [
      serviceTypes.cleaning,
      serviceTypes.maintenance,
      serviceTypes.security,
    ],
    roles: [ROLES.SECURITY_COMPANY_MANAGER.id, ROLES.MANAGER.id],
  },
  SITES: {
    link: '/location/sites',
    name: 'Sites',
    roles: [
      ROLES.SECURITY_COMPANY_MANAGER.id,
      ROLES.MANAGER.id,
      ROLES.SUPERVISOR.id,
    ],
    enableSite: true,
  },
  PERSONNEL: {
    link: '/people/personnel',
    name: 'Personnel',
    roles: [
      ROLES.SECURITY_COMPANY_MANAGER.id,
      ROLES.MANAGER.id,
      ROLES.SUPERVISOR.id,
    ],
  },
  EVENTS: {
    link: '/events',
    name: 'Events',
    roles: [
      ROLES.SECURITY_COMPANY_MANAGER.id,
      ROLES.MANAGER.id,
      ROLES.SUPERVISOR.id,
    ],
  },
  EVENT_TYPES: {
    link: '/event-types',
    name: 'Event Types',
    roles: [ROLES.SECURITY_COMPANY_MANAGER.id],
  },
  MESSAGES: {
    link: '/messages',
    name: 'Messages',
    alwaysVisible: true,
    //feature: [FEATURES.types.directMessaging.id],
  },
  BUSINESS_CLIENTS: {
    link: '/people/business',
    name: 'Business Clients',
    roles: [
      ROLES.SECURITY_COMPANY_MANAGER.id,
      ROLES.MANAGER.id,
      ROLES.SUPERVISOR.id,
    ],
  },
  CUSTOMERS: {
    link: '/people/customers',
    name: 'Customers',
    roles: [ROLES.SECURITY_COMPANY_MANAGER.id, ROLES.MANAGER.id],
  },
  DASHBOARD: {
    link: '/dashboard',
    name: 'dashboard',
    alwaysVisible: true,
  },
  CALENDAR: {
    link: '/calendar',
    name: 'Calendar',
    alwaysVisible: true,
  },
  WORK_ORDERS: {
    link: '/tasks/work-orders',
    name: 'Work Orders',
    services: [serviceTypes.maintenance],
    roles: [
      ROLES.SECURITY_COMPANY_MANAGER.id,
      ROLES.MANAGER.id,
      ROLES.SUPERVISOR.id,
    ],
  },
  EMERGENCIES: {
    link: '/tasks/emergencies',
    name: 'Emergencies',
    feature: [FEATURES.types.emergency.id],
  },
  TRIPS: {
    link: '/tasks/trips',
    name: 'Trips',
    services: [serviceTypes.transport.standard],
    roles: [
      ROLES.SECURITY_COMPANY_MANAGER.id,
      ROLES.MANAGER.id,
      ROLES.SUPERVISOR.id,
    ],
  },
  TRIP_TYPES: {
    link: '/tasks/tripTypes',
    name: 'Trip Types',
    services: [serviceTypes.transport.standard],
    roles: [ROLES.SECURITY_COMPANY_MANAGER.id],
  },
  VISITORS: {
    link: '/locations/visitors',
    name: 'Site Visitors',
    services: [serviceTypes.visitorManagement],
    roles: [
      ROLES.SECURITY_COMPANY_MANAGER.id,
      ROLES.MANAGER.id,
      ROLES.SUPERVISOR.id,
    ],
  },
  VISITOR_TYPES: {
    link: '/locations/visitor-types',
    name: 'Visitor Types',
    services: [serviceTypes.visitorManagement],
    roles: [ROLES.SECURITY_COMPANY_MANAGER.id, ROLES.MANAGER.id],
  },
  ZONES: {
    link: '/locations/zones',
    name: 'Zones',
    roles: [
      ROLES.SECURITY_COMPANY_MANAGER.id,
      ROLES.MANAGER.id,
      ROLES.SUPERVISOR.id,
    ],
  },
  ACCOUNT: {
    link: '/admin/account',
    name: 'Account',
    roles: [ROLES.SECURITY_COMPANY_MANAGER.id],
  },
  REGION: {
    link: '/region/region',
    name: 'Regions',
    roles: [ROLES.SRM_EMPLOYEE.id, ROLES.SRM_ADMIN.id],
  },
  PENDING_COMPANY: {
    link: '/region/pending',
    name: 'Pending Companies',
    roles: [ROLES.SRM_EMPLOYEE.id, ROLES.SRM_ADMIN.id],
  },
  COMPANY: {
    link: '/region/company',
    name: 'Companies',
    roles: [ROLES.SRM_EMPLOYEE.id],
  },
  ASSETS: {
    link: '/assets/assets',
    name: 'Assets',
    roles: [
      ROLES.SECURITY_COMPANY_MANAGER.id,
      ROLES.MANAGER.id,
      ROLES.SUPERVISOR.id,
    ],
  },
  ASSET_TYPES: {
    link: '/assets/types',
    name: 'Asset Types',
    roles: [
      ROLES.SECURITY_COMPANY_MANAGER.id,
      ROLES.MANAGER.id,
      ROLES.SUPERVISOR.id,
    ],
  },
  DEPARTMENTS: {
    link: '/people/departments',
    name: FEATURES.types.departments.header,
    feature: [FEATURES.types.departments.id],
    roles: [ROLES.SECURITY_COMPANY_MANAGER.id],
  },
  ATTENDANCE: {
    link: '/people/attendance',
    name: FEATURES.types.attendance.header,
    feature: [FEATURES.types.attendance.id],
    roles: [ROLES.SECURITY_COMPANY_MANAGER.id, ROLES.MANAGER.id],
  },
};

export const PAGE_NAME = {
  SECURITY_OPERATIONAL: 'operational',
  SECURITY: 'security',
  REPORTING: 'reporting',
  MANAGERIAL: 'managerial',
  ACCOUNT: 'account',
  REGION: 'region',
  EMERGENCY: 'emergency',
  TRANSPORT_OPERATIONAL: 'transportation',
  CLEANER_OPERATIONAL: 'cleanerOperational',
  MAINTENANCE_OPERATIONAL: 'maintenanceOperational',
  TEMPLATE_TASKS: 'template',
  CLEANING_TASKS: 'cleaning',
  WORK_ORDER_TASKS: 'workOrders',
  PERSONNEL: 'personnel',
  ZONES: 'zones',
  SITES: 'sites',
  EVENTS: 'events',
};

export const PRODUCT_NAME = {
  SECURITY: 'SECURITY',
  CLEANING: 'CLEANING',
  TRANSPORT: 'TRANSPORT',
  MAINTENANCE: 'MAINTENANCE',
};

export const PAGE_CONFIG = {
  [PAGE_NAME.SECURITY_OPERATIONAL]: {
    title: text.operational_view.title,
  },
  [PAGE_NAME.REPORTING]: {
    title: text.reporting_view.title,
  },
  [PAGE_NAME.MANAGERIAL]: {
    title: text.managerial_view.title,
  },
  [PAGE_NAME.ACCOUNT]: {
    noSubscriptionRequired: true,
    title: text.account_view.title,
  },
  [PAGE_NAME.REGION]: {
    noSubscriptionRequired: true,
    title: text.region_view.title,
  },
  [PAGE_NAME.EMERGENCY]: {
    title: text.emergency_view.title,
  },
  [PAGE_NAME.TRANSPORT_OPERATIONAL]: {
    title: text.transport_view.title,
  },
  [PAGE_NAME.CLEANER_OPERATIONAL]: {
    title: text.cleaner_operational_view.title,
  },
  [PAGE_NAME.MAINTENANCE_OPERATIONAL]: {
    title: text.maintenance_operational_view.title,
  },
};

export const STATUS_RESPONSE = {
  SUCCESS: 200,
  INVALID_REQUEST: 400,
  UNAUTHORISED: 401,
  NOT_FOUND: 404,
  VALIDATION_ERROR: 422,
  TIMEOUT: 500,
};

export const SUPPORT_EMAIL = 'support@securityrisk.com';

export const DEFAULT_EMPTY_VALUE = '-';

export const PANEL = {
  ZONE: 'zones',
  PERSONNEL: 'personnel',
  CLIENTS: 'customers',
  SITE: 'sites',
  ASSET: 'asset',
  ASSET_TYPE: 'asset-type',
  VISITOR: 'visitor',
  EVENTS: 'events',
  CLEANER_TASK: 'cleaningTasks',
  PATROL: 'patrols',
  EMERGENCY_RESPONSE: 'emergencyResponse',
  TRANSPORT: 'trips',
  COMPANY_PROFILE: 'securityCompany',
  MESSAGING: 'messaging',
  MAINTENANCE: 'maintenanceTasks',
  businessClient: 'business-client',
  SUBSCRIPTION: 'subscription',
  TASKS: 'tasks',
  DEPARTMENTS: 'departments',
  ATTENDANCE_TRACKING: 'attendance-tracking',
  MANAGERIAL: 'managerial',
};

export const PANEL_HEADERS = {
  ZONES: 'zones',
  PERSONNEL: 'personnel',
  CLIENTS: 'customers',
  SITES: 'sites',
  ASSETS: 'assets',
  ASSET_TYPES: 'asset-types',
  VISITORS: 'visitors',
  EVENTS: 'events',
  CLEANER_TASKS: 'tasks',
  PATROLS: 'patrols',
  TRANSPORT: 'trips',
  MESSAGING: 'messaging',
  businessClient: 'business-clients',
  EMERGENCY_RESPONSES: 'emergencyResponses',
  // SUBSCRIPTIONS: 'subscriptions',
  PRODUCTS: 'Products',
  ATTENDANCE_TRACKING: 'attendance-tracking',
  DEPARTMENTS: 'departments',
};

export const PANEL_SECTION_HEADER = {
  SERVICES: 'Services',
  ACCOUNT_INFO: 'Account Information',
};

export const PANEL_SPLIT = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal',
};

export const PANEL_SPLIT_SIZE = {
  VERTICAL_DEFAULT: '80%',
  VERTICAL_FULL: '100%',
  VERTICAL_CLOSED: '99.5%',
  HORIZONTAL_DEFAULT: '50%',
  HORIZONTAL_FULL: '100%',
};
/**
 * any exceptions in size of the map panel for a page please add here
 */
export const PAGE_PANEL_SPLIT_SIZE = {
  [PAGE_URLS.DASHBOARD.link]: '99.7%',
};
export const DEFAULT_DATE_FORMAT = 'DD/MMM/YYYY';
export const DEFAULT_DISPLAY_DATETIME_FORMAT = 'HH:mm DD/MMM/YYYY';

export const DB_NULL = 'UNSET';

export const DEFAULT_OPTION_LABEL_KEY = 'name';

export const ROLE_VIEW_MAP = {
  [ROLES.SECURITY_COMPANY_MANAGER.id]: [
    PAGE_NAME.EMERGENCY,
    PAGE_NAME.ACCOUNT,
    PAGE_NAME.MANAGERIAL,
    PAGE_NAME.CLEANER_OPERATIONAL,
    PAGE_NAME.SECURITY_OPERATIONAL,
    PAGE_NAME.MAINTENANCE_OPERATIONAL,
    PAGE_NAME.TRANSPORT_OPERATIONAL,
    PAGE_NAME.REPORTING,
  ],
  [ROLES.SRM_EMPLOYEE.id]: [PAGE_NAME.REGION, PAGE_NAME.EMERGENCY],
  [ROLES.SRM_ADMIN.id]: [PAGE_NAME.REGION],
  [ROLES.MANAGER.id]: [
    PAGE_NAME.EMERGENCY,
    PAGE_NAME.MANAGERIAL,
    PAGE_NAME.CLEANER_OPERATIONAL,
    PAGE_NAME.SECURITY_OPERATIONAL,
    PAGE_NAME.MAINTENANCE_OPERATIONAL,
    PAGE_NAME.TRANSPORT_OPERATIONAL,
    PAGE_NAME.REPORTING,
  ],
  [ROLES.SUPERVISOR.id]: [
    PAGE_NAME.EMERGENCY,
    PAGE_NAME.CLEANER_OPERATIONAL,
    PAGE_NAME.SECURITY_OPERATIONAL,
    PAGE_NAME.MAINTENANCE_OPERATIONAL,
    PAGE_NAME.TRANSPORT_OPERATIONAL,
  ],
};

export { ROLES };
